const ARO_FUNDING_INSTRUCTIONS_URL =
  process.env.REACT_APP_ARO_FUNDING_INSTRUCTIONS_URL

function getParticipantFileSubmitSuccessMessage(isPartialSubmission) {
  if (isPartialSubmission) {
    return `Your participant file has partially been submitted. Please provide any missing agreements or <a href=${ARO_FUNDING_INSTRUCTIONS_URL} target="_blank" rel="noreferrer noopener">view funding instructions.</a>`
  }

  return `We received your participant file, and we’ll send you an email when the participants are ready to be viewed in the platform. In the meantime,
  <a href=${ARO_FUNDING_INSTRUCTIONS_URL} target="_blank" rel="noreferrer noopener">view funding instructions.</a>`
}

export default getParticipantFileSubmitSuccessMessage
